import { createApi } from '@reduxjs/toolkit/query/react';

import { apiEvents } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export const typePrefix = 'events';

interface Event {
  name: string;
  start_date: string;
}

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiEvents }),
  tagTypes: ['events'],
  endpoints: (builder) => ({
    getEvents: builder.query<Event[], Request>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'events', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Event[]>(payload),
    }),
  }),
});

export const { useGetEventsQuery } = eventsApi;
